// extracted by mini-css-extract-plugin
export default {"pageLoading":"PageLoading_pageLoading__hQLFE"};